export default __webpack_public_path__ + "static/media/Thunder Mantle of the Living Legend.4cd47eaa.jpg";